import $ from 'jquery'; // 确保已引入jQuery
import './dialog.js'; // 引入原插件的代码
export default {
  install(Vue) {
    Vue.prototype.$dialog = {
      alert: function (content, title, okText, options) {
        // 合并配置
        var settings = $.extend({
          type: 'alert',
          content: content,
          titleText: title || '提示',
          buttonTextConfirm: okText || '确定'
        }, options);

        // 创建一个div元素，并调用插件
        var $div = $('<div />');
        $('body').append($div);
        return $div.dialog(settings);
      },
      confirm: function (content, title, okText, options) {
        var settings = $.extend({
          type: 'confirm',
          content: content,
          titleText: title || '提示',
          buttonTextConfirm: okText || '确定',
        }, options);

        var $div = $('<div />');
        $('body').append($div);
        return $div.dialog(settings);
      },
      // 可以继续添加其他类型的方法，如toast等
      toast: function (content, options) {
        var settings = $.extend({
          type: 'toast',
          content: content,
          autoClose: 3000
        }, options);

        var $div = $('<div />');
        $('body').append($div);
        return $div.dialog(settings);
      }
    }
  }
}
